import React from 'react'
import './advantages.css'

function INCSUBAdvantages() {

    const arr = [
        'Manage all your subscriptions in one app.',
        'Create a group, invite friends and family, and split costs effortlessly.',
        'Browse available pools, join instantly, and start enjoying your subscriptions.',
        'Easily credit and withdraw money from your wallet.',
        'Receive immediate resolution for any doubts regarding the platform.'
    ]
    
    return (
        <div className='INCSUBAdvantages_ctn'>
            <div className='INCSUBAdvantages_img_holder'>
                <img src='assets/images/advantageimg.png'  alt='advantageimg' />
            </div>
            <div className='INCSUBAdvantages_text'>
                <div className='INCSUBAdvantages_text_heading'>
                    {'What are the advantages of using this app?'}
                </div>
                <div className='INCSUBAdvantages_text_list_hld'>
                    {arr && arr?.map((text) => (
                        <div className='INCSUBAdvantages_text_list'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986" stroke="#E09710" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22 4L12 14.01L9 11.01" stroke="#E09710" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className='INCSUBAdvantages_text_list_text'>
                                {text}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default INCSUBAdvantages;
